export default __webpack_public_path__ + "static/white-nr-black-cork-e05522b5d8d9e2d51967d23c646c9fb7.png";